<template>
    <div class="default-page-header">
        <TextBlock :layout="composite"/>
        <TextBlock :layout="composite2" v-if="double"/>
        <Imageblock :layout="{
            imageblock: this.$parent.page.image
        }" v-if="layout.image"/>
    </div>
</template>
<script>
import TextBlock from '@/components/layout/TextBlock'
import Imageblock from '@/components/layout/ImageBlock'
export default {
    components: {
        TextBlock,
        Imageblock
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed:
    {
        double()
        {
            const { page } = this.$parent
            return (page.baseline && page.description)
        },
        composite()
        {
            const { page } = this.$parent
            return {
                baseline: `<h1>${page.name}</h1>`,
                description: `<p>${page.baseline || page.description}</p>`,
                columns: !this.double && (!!page.baseline || !!page.description)
            }
        },
        composite2()
        {
            const { page } = this.$parent
            return {
                baseline: `${page.description}`,
                description: `<p>${page.baseline || page.description}</p>`,
                columns: (!!page.baseline || !!page.description)
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.default-page-header
    margin-top: 10%
    margin-bottom: 10%
    overflow: hidden
    @media print
        margin-top: 0
        margin-bottom: 0
.post
    flex: 1
    width: 460px
    min-height: 420px
    border-top: 1px solid #e0e1e3
    border-bottom: 1px solid #e0e1e3
    border-left: 1px solid #e0e1e3
    box-sizing: border-box
    padding-left: 4.5%
    padding-right: 3.5%
    display: flex
    align-items: center
    &:last-child
        border-right: 1px solid #e0e1e3
.caption
    font-size: 50px
    color: #636772
    font-weight: 500
    line-height: 1.2
    min-height: 2.4em

</style>
